// extracted by mini-css-extract-plugin
export default {"box":"box__YKeZB","root":"root__dAVAv","pointer":"pointer__TKtmt","icon-btn":"icon-btn__qOXyK","iconBtn":"icon-btn__qOXyK","disabled":"disabled__YFHpM"};